// Lista de opções dos selects no visual do tema (a lista nativa não aceita CSS).
//
// Só no computador (mouse): no celular/tablet fica o seletor nativo, mais confortável ao toque.
// O <select> continua no formulário: mostra o valor, recebe o foco, envia o form e dispara
// "change" (ex.: a ordenação da listagem). Só a lista que abre é substituída.

const SELETOR = '.campo-v2--select select, .wpcf7 select';
let contador = 0;

function iniciarSelect(select) {
    if (select.multiple || select.dataset.selectV2) {
        return;
    }
    select.dataset.selectV2 = '1';

    // No campo do tema a lista acompanha a caixa inteira; nos formulários, o próprio select.
    const caixa = select.closest('.campo-v2') || select;
    const envoltorio = select.closest('.campo-v2') || select.parentElement;
    envoltorio.classList.add('select-v2');

    const id = `selectV2Lista${++contador}`;
    const lista = document.createElement('ul');
    lista.className = 'select-v2__lista';
    lista.id = id;
    lista.setAttribute('role', 'listbox');
    lista.hidden = true;
    envoltorio.appendChild(lista);

    select.setAttribute('aria-haspopup', 'listbox');
    select.setAttribute('aria-controls', id);
    select.setAttribute('aria-expanded', 'false');

    let ativo = -1;

    function itens() {
        return [...lista.children];
    }

    function destacar(indice) {
        const todos = itens();
        ativo = Math.max(0, Math.min(indice, todos.length - 1));
        todos.forEach((li, i) => li.classList.toggle('is-ativo', i === ativo));
        const li = todos[ativo];
        if (li) {
            select.setAttribute('aria-activedescendant', li.id);
            li.scrollIntoView({ block: 'nearest' });
        }
    }

    function montar() {
        lista.innerHTML = '';
        [...select.options].forEach((opcao, i) => {
            const li = document.createElement('li');
            li.id = `${id}-${i}`;
            li.setAttribute('role', 'option');
            li.dataset.indice = i;
            li.textContent = opcao.text;
            li.setAttribute('aria-selected', opcao.selected ? 'true' : 'false');
            li.classList.toggle('is-selecionado', opcao.selected);
            // Opção vazia ("Tipo de imóvel", "Valor até"): significa "qualquer um".
            li.classList.toggle('is-vazio', opcao.value === '');
            if (opcao.disabled) {
                li.setAttribute('aria-disabled', 'true');
            }
            lista.appendChild(li);
        });
    }

    function posicionar() {
        if (caixa === select) {
            // Formulários: logo abaixo do select, com a largura dele.
            lista.style.top = `${select.offsetTop + select.offsetHeight + 6}px`;
            lista.style.left = `${select.offsetLeft}px`;
            lista.style.minWidth = `${select.offsetWidth}px`;
        }
        // Se não couber abaixo, abre para cima.
        lista.classList.remove('is-acima');
        const r = lista.getBoundingClientRect();
        const topoCaixa = caixa.getBoundingClientRect().top;
        if (r.bottom > window.innerHeight - 8 && topoCaixa - r.height > 8) {
            lista.classList.add('is-acima');
        }
    }

    function abrir() {
        if (!lista.hidden) {
            return;
        }
        document.dispatchEvent(new CustomEvent('select-v2:abrir', { detail: lista }));
        montar();
        lista.hidden = false;
        envoltorio.classList.add('is-aberto');
        select.setAttribute('aria-expanded', 'true');
        posicionar();
        destacar(select.selectedIndex);
    }

    function fechar() {
        if (lista.hidden) {
            return;
        }
        lista.hidden = true;
        envoltorio.classList.remove('is-aberto');
        select.setAttribute('aria-expanded', 'false');
        select.removeAttribute('aria-activedescendant');
    }

    function escolher(indice) {
        const opcao = select.options[indice];
        if (!opcao || opcao.disabled) {
            return;
        }
        fechar();
        select.focus();
        if (select.selectedIndex !== indice) {
            select.selectedIndex = indice;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    // Clique no select: abre a lista do tema no lugar da nativa.
    select.addEventListener('mousedown', (e) => {
        if (e.button !== 0) {
            return;
        }
        e.preventDefault();
        select.focus();
        lista.hidden ? abrir() : fechar();
    });

    select.addEventListener('keydown', (e) => {
        const aberta = !lista.hidden;
        if (!aberta) {
            // Teclas que abririam a lista nativa.
            if (e.key === ' ' || e.key === 'Enter' || e.key === 'F4' || (e.altKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp'))) {
                e.preventDefault();
                abrir();
            }
            return;
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            destacar(ativo + 1);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            destacar(ativo - 1);
        } else if (e.key === 'Home' || e.key === 'End') {
            e.preventDefault();
            destacar(e.key === 'Home' ? 0 : itens().length - 1);
        } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            escolher(ativo);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            fechar();
        } else if (e.key === 'Tab') {
            fechar();
        } else if (e.key.length === 1) {
            // Digitar uma letra vai para a próxima opção que começa com ela.
            const letra = e.key.toLowerCase();
            const todos = itens();
            for (let passo = 1; passo <= todos.length; passo++) {
                const i = (ativo + passo) % todos.length;
                if (todos[i].textContent.trim().toLowerCase().startsWith(letra)) {
                    destacar(i);
                    break;
                }
            }
        }
    });

    lista.addEventListener('mousedown', (e) => e.preventDefault());
    lista.addEventListener('click', (e) => {
        const li = e.target.closest('li');
        if (li) {
            escolher(Number(li.dataset.indice));
        }
    });
    lista.addEventListener('mousemove', (e) => {
        const li = e.target.closest('li');
        if (li && Number(li.dataset.indice) !== ativo) {
            destacar(Number(li.dataset.indice));
        }
    });

    select.addEventListener('blur', () => window.setTimeout(() => {
        if (document.activeElement !== select) {
            fechar();
        }
    }, 120));
    document.addEventListener('mousedown', (e) => {
        if (!envoltorio.contains(e.target)) {
            fechar();
        }
    });
    // Só uma lista aberta por vez.
    document.addEventListener('select-v2:abrir', (e) => {
        if (e.detail !== lista) {
            fechar();
        }
    });
    window.addEventListener('resize', () => {
        if (!lista.hidden) {
            posicionar();
        }
    });
}

export default {
    init() {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            return;
        }
        document.querySelectorAll(SELETOR).forEach(iniciarSelect);
    },
};
